import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  BASE_URL,
  getToken,
  getCurrentLanguage,
} from "../../shared/utils.js/utils";

// Get leave reports
export const getLeaveReports = createAsyncThunk(
  "LeaveReports/getLeaveReports",
  async (dates, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      if (!token) {
        throw new Error("No authentication token found");
      }
      const queryParams = new URLSearchParams();
      queryParams.append("start_date", dates.start_date);
      queryParams.append("end_date", dates.end_date);
      const url = `${BASE_URL}/hr-reports/leaves?${queryParams.toString()}`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": currentLang,
        },
      });
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to get leave reports!";
      return rejectWithValue(message);
    }
  },
);
